import BucketIcon from '@svg/bucket_icon';

import { ListItemContainer, ListItemContent, ListItemProps } from './ListItem';
import { Stack } from '@mui/material';

export const BucketListItem: React.FC<ListItemProps> = (props) => {
  const { option, key, ...liProps } = props;

  return (
    <ListItemContainer key={key} {...liProps}>
      <Stack height='20px' direction='row' alignItems='center' justifyContent='center'>
        <BucketIcon height={14} />
      </Stack>
      <ListItemContent>
        <h1>{option.label}</h1>
      </ListItemContent>
    </ListItemContainer>
  );
};
